const languages = {
    es:{
      idioma: "Idioma",
      inversores: "Inversores",
      docs: "Docs",
      documentos: "Documentos",
      analiza: "Analiza tu inversión",
      cargando: "Cargando datos...",
      buscar: "Buscar inversor",
      busquedaHolder: "BUSQUE POR NOMBRE",
      descargarExcel: "Descargar Excel",
      grupo: "Grupo",
      compromiso: "Compromiso",
      compromisoGrafico: "Comp.",
      contribuciones: "Contribuciones",
      distribuciones: "Distribuciones",
      shares: "Participaciones",
      tuInversion: "Resumen",
      documentosInversores: "Documentos de inversores",
      nombreDocumento: "Nombre del Documento",
      fondos: "Fondos",
      fof: "Fondo de Fondos",
      coinvestFunds: "Fondos de coinversión",
      anuncios: "Anuncios",
      portalInversor: "Portal del inversor",
      contacto: "Contacto",
      accesoDenegado: "Acceso denegado",
      accesoDenegadoTexto: "El usuario actual no tiene acceso a esta aplicación",
      SeleccionaDocumento: "Selecciona un documento",
      ampliar: "Ampliar",
      seleccionarTodos: "Seleccionar Todos",
      diaInversor: "Día del Inversor",
      verTutorial: "Ver tutorial",
      descargarInfo: "Ver info",
      verEvento: "Ver evento",
      presentacion: "Presentación",
      noMostrarMas: "No volver a mostrar",
      planifica: "Planifica tu inversión",
      videos: "Vídeos",
      ayuda: "Ayuda",
      dataRoom: "Data Room",
      enlarge: 'Pantalla completa',
      download: 'Descargar',
      fondoSeleccionado: "Fondo seleccionado",
      noInvestorsAsociados: "No hay inversores asociados a este usuario",
      desembolsos: "Desembolsos",
      pendiente: "Pendiente",
      valoracion: "Valoración",
      verInforme: "Ver informe",
      bienvenido: "Bienvenido al Portal del Inversor",
      resumen: "Resumen",
      media: "Media",
      continuationFinance: "Fondos de deuda",
      separateManagedAccounts: "Cuentas segregadas",
      ultimaValoracion: "Última valoración disponible a",
      buscarPorInversor: "Buscar por inversor",
      buscarPorFondo: "Buscar por fondo",
      principalesMagnitudes: "Evolución de las principales magnitudes del Fondo",
			trimActual: "Trimestre actual",
			trimAnterior: "Trimestre anterior",
			variacion: "Variación",
      compromisoTotal: "Total patrimonio comprometido",
      desembolsoDeParticipes: "Desembolso de partícipes",
      distribucionesAcumuladas: "Distribuciones acumuladas",
      compromisoPendiente: "Compromiso pendiente",
      compromisoTotalFondos: "Total comprometido en fondos",
      desembolsoFondosSubyacentes: "Desembolso en fondos subyacentes",
      distribucionesRecibidasFondo: "Distribuciones recibidas por el Fondo",
      valoracionCarteraTotal: "Valoración de la Cartera",
      posicionNetaCaja: "Cuenta neta de la caja",
      valorTotalActivoNeto: "Valor total de la inversión (NAV)",
      multiploDistribucionCapital: "Múltiplo de distribución (DPI)",
      multiploValorResidualCapital: "Múltiplo de valor residual (RPI)",
      multiploTotalValorCapital: "Múltiplo total para el inversor (TVPI)",
      detallePorInversor: "Detalle por Inversor",
      detallePorFondo: "Detalle por Fondo",
      desdeTrimestre: "Desde",
      hastaTrimestre: "Hasta",
      valorPosicion: "Valor posición",
      detalleMovimientos: "Detalle movimientos",
      inversion: "Inversión",
      fecha: "Fecha",
      valorLiquidativo: "Valor liquidativo",
      evolucionValorLiquidativo: "Evolución del valor liquidativo",
      valorLiquidativoProforma: "Valor liquidativo proforma",
      generar: 'Generar',
      certificadoDeParticipacion: 'Certificado de participación',
      certificadoParticipacion: 'Certificado participación',
      solicitudDesembolso: 'Solicitud de desembolso',
      cartaCompromiso: 'Carta de compromiso',
      notificacionDistribucion: 'Notificación de distribución',
      enFecha: 'En fecha',
      generarDocumentos: 'Generar documentos',
      cerrar: 'Cerrar',
      abrirDocumento: 'Abrir documento',
      verDocumentos: 'Ver documentos',
      CapitalCalls: 'Llamada de capital',
      Distribution: "Distribución",
      Transfer: "Transferencia",
      Closing: "Compromiso",
      generandoDocumento: 'Generando documento',
      grafico: 'Gráfico',
      estimacionCashflows: 'Estimación Cashflows',
      otros: 'Otros',
      analisisCartera: 'Análisis de cartera',
      control: 'Control',
      capitalCallNoPago: 'Llamado de capital no pagado. Haga click para más información',
      certificadoDeParticipacionAFecha: 'Certificado de participación a fecha',
      informacionAFecha: 'Información a ',
      porInversor: 'Por inversor',
      porFondo: 'Por fondo',
      navPrevQuarter: "Trimestre anterior",
      valuation: "Valoración",
      netCash: "Caja neta",
      newInvestment: "Nuevas inversiones",
      distribution: "Distribuciones",
      totalNav: "Nav total",
      graficosDelFondo: "Gráficos del fondo",
      generarDocumento: "Generar documentos",
      documentosDelFondo: "Documentos del fondo",
      inversor: 'Inversor',
      seleccioneFormulario: 'Seleccione los documentos que desea generar',
      seleccioneMismoVehiculo: 'Seleccione inversores del mismo vehículo',
      flujos: 'Flujos',
      capitalCalls: "Llamadas de capital",
      distributions: "Distribuciones",
      pending: "Desembolso pendiente",
      residualValue: "Valor residual",
      totalValue: "Valor total",
      commitment: "Compromiso",
      acumulado: "Acumulado",
      noInvestorsSelected: "Por favor seleccione al menos un inversor para generar la vista",
      noPeipSelected: "Por favor seleccione un vehículo para generar la vista",
      actividadReciente: "Actividad reciente",
      leerMas: "Leer más",
      noticias: "Noticias",
      enero: "Enero",
      febrero: "Febrero",
      marzo: "Marzo",
      abril: "Abril",
      mayo: "Mayo",
      junio: "Junio",
      julio: "Julio",
      agosto: "Agosto",
      septiembre: "Septiembre",
      octubre: "Octubre",
      noviembre: "Noviembre",
      diciembre: "Diciembre",
      newsletter: "últimas comunicaciones",
      quarterReport: "Informe trimestrales",
      sinData: "No hay información reciente",
      home: "Inicio",
      privacyPolicy: 'Política de privacidad',
      cookiesPolicy: 'Política de cookies',
      disclaimer: 'Aviso legal',
      allRightsReserved: 'Todos los derechos reservados',
      cargarMas: 'Cargar más',
      fechasCombinadas: "Si se seleccionan múltiples inversores, las fechas en el listado corresponden a todos ellos. Tenga en cuenta que al generar el documento, algunos inversores podrían no figurar si no tienen movimientos en esa fecha específica.",
      noDataFound: "No se han encontrado datos",
      loadingChart: "Cargando gráfico...",
      noPermissions: "Lo sentimos, no tiene permisos para acceder a esta sección",
      welcomeTo: "Bienvenido al",
      investorPortal: "Portal del Inversor",
      sobreCompromisoTotal: "Porcentaje calculado en base al total comprometido",
      sobreeTotalDesembolsado: "Porcentaje calculado en base al total desembolsado",
      analisis: 'Análisis',
      estadoActual: 'Estado actual',
	  informationToday: "Información a",
	  netAssetDisclaimer: "Valor liquidativo a la fecha de la última valoración trimestral reportada. ",
	  netAssetProformaDisclaimer: "El valor liquidativo proforma incluye los desembolsos y distribuciones a coste que se han producido tras la última fecha de valoración reportada.",
	  lookingAt: "Viendo",
	  outOf: "de",
	  investors: "inversores",
	  noMoreInvestors: "Se han mostrado todos los inversores",
	  viewMore: "Cargar más",
	  moreThan: "Más de",
	  noResults: "inversores coinciden con los criterios de búsqueda. Por favor, refine su búsqueda para obtener menos resultados.",
	  valuationDate: "Fecha de valoración",
	  valuationType: "Tipo de valoración",
	  proforma: "Proforma",
	  	  
	  /*DATA RECOLECTION */
	  informationOutdated: "Información desactualizada",
	  completeOutdatedInformation: "Por favor, complete los datos faltantes utilizando el botón que aparece a continuación",
	  completeData: "Completar información",
	  remindMeLater: "Recordarme más tarde",
	  back: "Volver",
	  next: "Siguiente",
	  add: "Agregar",
	  completeField: "Complete el campo",
	  selectAnOption: "Seleccione una opción",
	  selectADate: "Seleccione una fecha",
	  addFoundOrigin: "Agregar origen de fondos",
	  updateData: "Actualización de datos",
	  updateDataInfo: "En cumplimiento con la norma de Prevención de Lavado de Activos y Financiamiento del Terrorismo (PLAFIT), le solicitamos que actualice sus datos personales. Por favor, seleccione el inversor para el cual desea actualizar la información.",
	  selectInvestor: "Seleccione un inversor para comenzar",
	  start: "Comenzar",
	  investorData: "Datos del inversor",
	  activitySector: "Sector de actividad",
	  lastExcerciseIncome: "Ingresos del último ejercicio",
	  lastExcerciseNetWorth: "Patrimonio neto del último ejercicio",
	  foundsOrigin: "Origen de fondos",
	  documentToUpload: "Documento a cargar",
	  supportDocument: "Documento",
	  uploadDocument: "Cargar documento",
	  ocdeTitle: "¿Cotiza el Inversor en un mercado oficial o bolsa de valores de un estado miembro de la OCDE?",
	  ocdeName: "Nombre de la autoridad competente",
	  ocdeCountry: "País de la autoridad competente",
	  ocdeWebsite: "Página web (en su caso)",
	  ocdeRegistrationNumber: "Número de registro (en su caso)",
	  taxAddress: "Domicilio fiscal",
	  searchAddress: "Buscar dirección",
	  addressSecondLine: "Apartament, unidad, edificio, piso, etc. (opcional)",
	  beneficialOwners: "Titulares reales",
	  beneficialOwnersData: "Datos del titular real",
	  names: "Nombres",
	  firstLastName: "Primer apellido",
	  secondLastName: "Segundo apellido",
	  email: "Correo electrónico",
	  isPrp: "PRP o allegado de PRP",
	  prpPosition: "Cargo del PRP",
	  taxCountry: "País de residencia fiscal",
	  identityDocument: "Documento de identidad o pasaporte",
	  documentNumber: "Número de documento",
	  dateOfExpiration: "Fecha de caducidad",
	  dateOfBirth: "Fecha de nacimiento",
	  nationality: "Nacionalidad",
	  participationPercentage: "Porcentaje de participación",
	  beneficialOwnersFile: "Acta de titularidad real o nota del Registro Mercantil (con fecha menor a 6 meses)",
	  verifyDocument: "Compruebe que los datos del documento de identidad o pasaporte vigente han sido rellenados correctamente",
	  noBeneficialOwners : "No hay titulares reales. Por favor, añada los correspondientes.",
	  representatives: "Información de representantes y apoderados",
	  isRepresentative: "es representante o apoderado",
	  representativeData: "Datos del representante o apoderado",
	  representation: "Representación",
	  representationType: "Tipo de representación",
	  representativesDocumentFile: "Escritura de nombramiento o apoderamiento, o nota simple del Registro Mercantil (con fecha menor a 6 meses)",
	  noRepresentatives: "No hay representantes. Por favor, añada los correspondientes.",
	  contacts: "Contactos",
	  contactData: "Datos de contacto",
	  isContact: "es contacto",
	  phone: "Teléfono",
	  communicationPreferences: "Preferencias de comunicación",
	  noContacts: "No hay contactos. Por favor, añada los correspondientes.",
	  confirmation: "Confirmación",
	  confirmationText: "¿Confirma que los datos introducidos son correctos y completos?",
	  send: "Enviar",
	  keepEditing: "Seguir editando",
	  onePrincipalContact: "Debe seleccionar al menos un contacto como contacto principal",
	  completeMandatoryFields: "Por favor, complete los campos obligatorios antes de continuar",
	  city: "Ciudad",
	  country: "País",
	  postalCode: "Código postal",
	  fieldNotEditable: "Campo no editable, complete el campo Dirección para buscar.",
	  readingDocument: "Leyendo documento...",
	  invalidEmail: "El correo electrónico introducido no es válido. Por favor, introduzca un correo electrónico válido.",
	  signatoriesData: "Datos de los firmantes",
	  signatory: "Firmante",
	  signatoryActivities: "Actividad del firmante",	  
	  position: "Cargo",
	  yes: "Sí",
	  situation: "Situación laboral",
	  duplicateEmails: "Se han encontrado dos o más direcciones de correo duplicadas en la lista. Cada correo debe ser único",
	  dataReceived: "Información recibida",
	  dataReceivedText: "La información proporcionada ha sido recibida correctamente y se encuentra actualmente en proceso de revisión.",
	  goToStart: "Ir al inicio",
	  noNeedToUpdate: "Actualmente no hay inversores asociados a este usuario que necesiten actualizar sus datos. Puede volver al portal del inversor para revisar su información o gestionar otras operaciones.",
	  goToHomePage: "Volver al Portal del Inversor",
	  twoLatestPayslipsRequired: "Las dos nóminas deben cargarse en un único documento",
	  uploadDocumentTooltip: "Formatos permitidos: PDF, JPG, PNG. Tamaño máximo: 10MB.",
	  otherActivitySector: "Especificar sector de actividad",
	  prpDisclaimer1: "Personas con responsabilidad pública: jefes de Estado, jefes de Gobierno, ministros, subsecretarios o secretarios de Estado; parlamentarios; miembros de tribunales supremos, tribunales constitucionales u otras altas instancias judiciales cuyas decisiones no admitan normalmente recurso, salvo en circunstancias excepcionales; miembros de tribunales de cuentas o de los consejos de bancos centrales; embajadores encargados de negocios y altos funcionarios de las fuerzas armadas; miembros de los órganos administrativos, de gestión o de supervisión de empresas de propiedad estatal. Art. 14 de la Ley 10/2010 de 28 de Abril.",
	  prpDisclaimer2: "Familiares más próximos: el cónyuge; toda persona que, con arreglo a la legislación nacional, sea asimilable al cónyuge; los padres e hijos y sus cónyuges o personas asimilables a cónyuges. Allegados: persona física de la que sea notorio que participa en la propiedad de una entidad conjuntamente con alguna de las personas políticamente expuestas, o mantenga relaciones empresariales estrechas con las mismas; toda persona física que ostente la propiedad económica de una entidad jurídica que notoriamente se haya constituido en beneficio de la persona políticamente expuesta. Art. 14 de la Ley 10/2010 de 28 de Abril.",
	  contactsDisclaimer: "Por favor, indíquenos los contactos que desea que reciban los distintos tipos de comunicaciones que enviamos."
	},
    en: {
      idioma: "Language",
      inversores: "Investors",
      docs: "Docs",
      documentos: "Documents",
      analiza: "Analyze your investment",
      cargando: "Loading data...",
      buscar: "Search investor",
      busquedaHolder: "SEARCH BY NAME",
      descargarExcel: "Download Excel",
      grupo: "Group",
      compromiso: "Commitment",
      compromisoGrafico: "Comm.",
      contribuciones: "Amount",
      distribuciones: "Distributions",
      shares: "Shares",
      tuInversion: "Resume",
      documentosInversores: "Investor documents",
      nombreDocumento: "Document name",
      fondos: "Funds",
      fof: "Fund of Funds", 
      coinvestFunds: "Co-investment funds",
      anuncios: "Announcements",
      portalInversor: "Investor portal",
      contacto: "Contact",
      accesoDenegado: "Access denied",
      accesoDenegadoTexto: "The current user does not have access to this application",
      SeleccionaDocumento: "Select a Document",
      fondoSeleccionado: "Selected Fund",
      ampliar: "Open",
      seleccionarTodos: "Select All",
      ayuda: "Help",
      diaInversor: "Investor Day",
      verEvento: "View event",
      descargarInfo: "View info",
      verTutorial: "View tutorial",
      presentacion: "Presentation",
      noMostrarMas: "Don't show again",
      planifica: "Plan your investment",
      videos: "Videos",
      dataRoom: "Data Room",
      enlarge: 'Full screen',
      download: 'Download',
      noInvestorsAsociados: "No investors asociated to this user",
      desembolsos: "Capital Calls",
      pendiente: "Pending",
      valoracion: "Valuation",
      verInforme: "View report",
      bienvenido: "Welcome to the Investor Portal",
      resumen: "Summary",
      media: "Media",
      continuationFinance: "Continuation Finance",
      separateManagedAccounts: "Separate Managed Accounts",
      principalesMagnitudes: "Main figures evolution of the Fund",
      trimActual: "Current quarter",
			trimAnterior: "Previous quarter",
			variacion: "Variation",
      ultimaValoracion: "Last valuation available at",
      buscarPorInversor: "Search by investor",
      buscarPorFondo: "Search by fund",
      compromisoTotal: "Total commitment to the Fund",
      desembolsoDeParticipes: "Total paid in capital",
      distribucionesAcumuladas: "Cumulative distributions to investors",
      compromisoPendiente: "Unfunded commitment for drawdown",
      compromisoTotalFondos: "Total commitment in portfolio companies",
      desembolsoFondosSubyacentes: "Total invested in portfolio companies",
      distribucionesRecibidasFondo: "Cumulative distributions",
      valoracionCarteraTotal: "Total fair value of the current companies",
      posicionNetaCaja: "Net cash position",
      valorTotalActivoNeto: "Total net asset value (NAV)",
      multiploDistribucionCapital: "Distributions to paid-in-capital (DPI)",
      multiploValorResidualCapital: "Residual Value to paid-in-capital (RPI)",
      multiploTotalValorCapital: "Total Value to paid-in-capital (TVPI)",
      detallePorInversor: "Investor detail",
      detallePorFondo: "Fund detail",
      desdeTrimestre: "From",
      hastaTrimestre: "To",
      valorPosicion: "Account Valuation",
      detalleMovimientos: "Movements details",
      inversion: "Investment",
      fecha: "Date",
      valorLiquidativo: "Net Asset Value",
      generar: 'Generate',
      certificadoDeParticipacion: 'Capital Account',
      certificadoParticipacion: 'Capital Account',
      solicitudDesembolso: 'Capital Call Notice',
      cartaCompromiso: 'Commitment Agreement',
      notificacionDistribucion: 'Distribution Notice',
      enFecha: 'On date',
      generarDocumentos: 'Generate documents',
      cerrar: 'Close',
      abrirDocumento: 'Open document',
      verDocumentos: 'View documents',
      CapitalCalls: 'Capital Call',
      Distribution: "Distribution",
      Transfer: "Transfer",
      Closing: "Commitment",
      generandoDocumento: 'Generating document',
      valorLiquidativoProforma: "Proforma Net Asset Value",
      grafico: 'Chart',
      estimacionCashflows: 'Cashflows estimation',
      otros: 'Others',
      analisisCartera: 'Portfolio analysis',
      control: 'Control',
      capitalCallNoPago: 'Unpaid Capital Call. Click for more information',
      certificadoDeParticipacionAFecha: 'Capital Account as of',
      informacionAFecha: 'Information up to',
      porInversor: 'By investor',
      porFondo: 'By fund',
      navPrevQuarter: "Previous quarter",
      valuation: "Valuation",
      netCash: "Net cash",
      newInvestment: "New investments",
      distribution: "Distributions",
      totalNav: "Total Nav",
      graficosDelFondo: "Fund charts",
      documentosDelFondo: "Funds\' documents",
      inversor: 'Investor',
      seleccioneFormulario: 'Select the documents you want to generate',
      seleccioneMismoVehiculo: 'Select investors of the same vehicle',
      generarDocumento: 'Generate documents',
      flujos: 'Flows',
      commitment: "Commitment",
      capitalCalls: "Capital Calls",
      distributions: "Distributions",
      pending: "Pending drawdown",
      residualValue: "Residual Value",
      totalValue: "Total Value",
      acumulado: "Cumulative",
      noInvestorsSelected: "Please select at least one investor to generate the view",
      noPeipSelected: "Please select a vehicle to generate the view",
      evolucionValorLiquidativo: "Net Asset Value evolution",
      actividadReciente: "Recent activity",
      leerMas: "Read more",
      noticias: "News",
      enero: "January",
      febrero: "February",
      marzo: "March",
      abril: "April",
      mayo: "May",
      junio: "June",
      julio: "July",
      agosto: "August",
      septiembre: "September",
      octubre: "October",
      noviembre: "November",
      diciembre: "December",
      newsletter: "latest communications",
      quarterReport: "Quarterly reports",
      sinData: "No recent information",
      home: "Home",
      privacyPolicy: 'Privacy policy',
      cookiesPolicy: 'Cookies policy',
      disclaimer: 'Disclaimer',
      allRightsReserved: 'All rights reserved',
      cargarMas: 'Load more',
      fechasCombinadas: "If multiple investors are selected, the dates in the list correspond to all of them. Please note that when generating the document, some investors may not appear if they have no transactions on that specific date.",
      noDataFound: "No data found",
      loadingChart: "Loading chart...",
      noPermissions: "Sorry, you don't have permissions to access this section",
      welcomeTo: "Welcome to",
      investorPortal: "Investor Portal",
      sobreCompromisoTotal: "Percentage based on total commitment",
      sobreeTotalDesembolsado: "Percentage based on total paid in capital",
      analisis: 'Analysis',
      estadoActual: 'Current state',
	  informationToday: "Information as of",
	  netAssetProformaDisclaimer: "The pro forma net asset value per share incorporates capital calls and distributions at cost that occurred after the latest reported valuation date.",	  
	  netAssetDisclaimer: "Net Asset Value per share as of the latest reported quarter.",	  
	  lookingAt: "Viewing",
	  outOf: "out of",	
	  investors: "investors",
	  noMoreInvestors: "No more investors to show",
	  viewMore: "Load more",
	  moreThan: "More than",
	  noResults: "investors match the search criteria. Please refine your search to get fewer results.",
	  valuationDate: "Valuation date",
	  valuationType: "Valuation type",
	  proforma: "Proforma",

	  /*DATA RECOLECTION */
	  informationOutdated: "Outdated information",
	  completeOutdatedInformation: "Please complete the missing data using the button below",
	  completeData: "Complete information",
	  remindMeLater: "Remind me later",
	  back: "Back",
	  next: "Next",
	  add: "Add",
	  completeField: "Complete the field",
	  selectAnOption: "Select an option",
	  selectADate: "Select a date",
	  addFoundOrigin: "Add founds source",
	  updateData: "Update data",
	  updateDataInfo: "In compliance with the Anti-Money Laundering and Terrorism Financing (AML/CFT) regulations, we request that you update your personal information. Please select the investor for whom you wish to update the information.",
	  selectInvestor: "Select an investor to begin",
	  start: "Start",
	  investorData: "Investor data",
	  activitySector: "Activity sector",
	  lastExcerciseIncome: "Last excercise income",
	  lastExcerciseNetWorth: "Last excercise net worth",
	  foundsOrigin: "Founds source",
	  documentToUpload: "Document to upload",
	  supportDocument: "Document",
	  uploadDocument: "Upload document",
	  ocdeTitle: "Is the Investor listed in an official market exchange in an OECD member state?",
	  ocdeName: "Name of the competent authority",
	  ocdeCountry: "Country of the competent authority",
  	  ocdeWebsite: "Website (if applicable)",
 	  ocdeRegistrationNumber: "Registration number (if applicable)",
	  taxAddress: "Tax address",
	  searchAddress: "Search address",
	  addressSecondLine: "Apartment, unit, building, floor, etc. (optional)",
	  beneficialOwners: "Beneficial owners",
	  beneficialOwnersData: "Beneficial owner data",
	  names: "Names",
	  firstLastName: "First last name",
	  secondLastName: "Second last name",
	  email: "Email",
	  isPrp: "PRP or PRP relative",
	  prpPosition: "PRP position",
	  taxCountry: "Tax residence country",
	  identityDocument: "Identity document or passport",
	  documentNumber: "Document number",
	  dateOfExpiration: "Expiration date",
	  dateOfBirth: "Birth date",
	  nationality: "Nationality",
	  participationPercentage: "Participation percentage",
	  beneficialOwnersFile: "Beneficial ownership certificate or note from the Commercial Registry (dated within the last 6 months)",
	  verifyDocument: "Please ensure that the details of the valid identity document or passport have been filled in correctly",
	  noBeneficialOwners : "There are no beneficial owners. Please add the corresponding ones.",
	  representatives: "Representatives and proxies information",
	  isRepresentative: "is a representative or proxy",
	  representativeData: "Representative or proxy data",
	  representation: "Representation",
	  representationType: "Type of representation",
	  representativesDocumentFile: "Appointment or proxy deed, or simple note from the Commercial Registry (dated within the last 6 months)",
	  noRepresentatives: "There are no representatives. Please add the corresponding ones.",
	  contacts: "Contacts",
	  contactData: "Contact data",
	  isContact: "is a contact",
	  phone: "Phone",
	  communicationPreferences: "Communication preferences",
	  noContacts: "There are no contacts. Please add the corresponding ones.",
	  confirmation: "Confirmation",
	  confirmationText: "Do you confirm that the entered data is correct and complete?",
	  send: "Send",
	  keepEditing: "Keep editing",
	  onePrincipalContact: "You must select at least one contact as the main contact",
	  completeMandatoryFields: "Please complete the mandatory fields before proceeding",
	  city: "City",
	  country: "Country",
	  postalCode: "Postal code",
	  fieldNotEditable: "Field not editable, complete the Address field to search.",
	  readingDocument: "Reading document...",
	  invalidEmail: "The entered email is not valid. Please enter a valid email address.",
	  signatoriesData: "Signatories data",
	  signatory: "Signatory",
	  signatoryActivities: "Signatory activity",
	  position: "Position",
	  yes: "Yes",
	  situation: "Employment situation",
	  duplicateEmails: "Two or more duplicate email addresses were found in the list. Each email must be unique.",
	  dataReceived: "Information received",
	  dataReceivedText: "The information you provided has been successfully received and is currently under review.",
	  goToStart: "Go to start",
	  noNeedToUpdate: "There are currently no investors associated with this user that require data updates. You can return to the investor portal to review information or perform other actions.",
	  goToHomePage: "Return to the Investor Portal",
	  twoLatestPayslipsRequired: "The two payslips must be uploaded in a single document",
	  uploadDocumentTooltip: "Allowed formats: PDF, JPG, PNG. Maximum size: 10MB.",
	  otherActivitySector: "Specify activity sector",
	  prpDisclaimer1: "Means an individual who is, or has at any time in the preceding year held one of the following positions or a similar position: heads of state, heads of government, ministers and deputy or assistant ministers; members of parliaments; judges of the Supreme Courts, judges of constitutional courts or of other high-level judicial bodies whose decisions are not subject to further appeal, other than in exceptional circumstances; higher officials at auditing authorities and members of governing bodies of central banks; ambassadors, chargés d’affaires and high-ranking officers in the armed forces; and members of the administrative, management or supervisory bodies of State-owned enterprises, together with persons who hold or who have previously held positions at Community level and international level. Art. 14 de la Ley 10/2010 de 28 de Abril.",
	  prpDisclaimer2: "Immediate family member: spouse (or equivalent partner), children and their spouses or partners and the person’s parents. Known close associate: any individual who is known to have joint beneficial ownership of a legal entity or legal arrangement any other close business relations and any individual who has sole beneficial ownership of a legal entity or legal arrangement which is known to have been set up for the benefit of a politically exposed person. Article 14 of Law 10/2010 of April, 28.",
	  contactsDisclaimer: "Please let us know the contacts you would like to receive the various types of communications we send.",
	}
  }
  export {languages};